<template>
  <span :style="{'top': top+'%', 'left': left+'%', 'animation': 'star-ani '+duration+'s infinite linear', 'animation-delay': delay+'ms'}" class="estrella-fugaz">
    <span class="cola" :style="{'animation': 'shooting-ani '+duration+'s infinite linear', 'animation-delay': delay+'ms'}"></span>
  </span>
</template>

<script>
export default {
  name: 'Estrella',
  data: function(){
      return {
        top: 0,
        left: 0,
        delay: 0,
        duration: 0
      }
  },
  mounted(){
    this.top = Math.floor(Math.random() * 20) + 1;
    this.left = Math.floor(Math.random() * 100) + 1;
    this.delay = Math.floor(Math.random() * 5000) + 1;
    this.duration = Math.floor(Math.random() * 10) + 5;
  }
}
</script>

<style lang="scss">
.estrella-fugaz {
  display:block;
  width:4px;
  height:4px;
  border-radius:50%;
  // background:#FFF;
  top:100px;
  left:400px;
  position:absolute;
  transform-origin:100% 0;
  opacity:0;
  will-change: transform, opacity;
  animation:star-ani 10s infinite linear;
  animation-direction: normal;
}
.cola {
  position:absolute;
  top:0px;
  left:4px;
  border:2px solid #F00;
  border-width:2px 100px 2px 100px; 
  border-color:transparent transparent transparent #FFF;
  will-change: transform;
  transform:rotate(-45deg) translate3d(1px, -1px, 0);
  transform-origin:0% 100%;
  animation: shooting-ani 10s infinite linear;
  animation-direction: normal;
}

@keyframes shooting-ani {
  0% {
    transform:scale(0.1) rotate(-45deg) translate(0px, 0px);
  }
  5% {
    transform:scale(1) rotate(-45deg) translate(0px, 0px);
  }
  10% {
    transform:scale(0.1) rotate(-45deg) translate(0px, -1px);
  }
  100% {
    transform:scale(0.1) rotate(-45deg) translate(0px, -1px);
  }
}

@keyframes star-ani {
  0% {
    opacity:0;
    transform:scale(0) rotate(0) translate3d(0, 0, 0);
  }
  5% {
    opacity:1;
    transform:scale(1) rotate(0) translate3d(-100px, 100px, 0);
  }
  10% {
    opacity:0;
    transform:scale(2) rotate(0) translate3d(-200px, 200px, 0);
  }
  100% {
    opacity:0;
    transform:scale(2) rotate(0) translate3d(-200px, 200px, 0);
  }
  
}
</style>
